RoundAPIService = ($http, $q, $location) ->
  rounds = {}
  getRound: (id, fromRoundDetail, params) ->
    rounds[id] = null if fromRoundDetail
    round = rounds[id]
    delay = $q.defer()
    unless round
      $http.get("/api/score_cards/#{id}.json",params: params).then(
        (resp) ->
          rounds[id] = resp.data
          delay.resolve resp.data
      ,
        (error) ->
          #For the case another user go directly to user round
          #https://tr.ygo.jp/redmine/issues/11197
          $location.path('/') if error.data.code is 'error.resource_not_found'
          delay.reject error.data
      )
    else
      delay.resolve round
    delay.promise

  uploadScore: (params) ->
    $http.post('/api/score_cards/upload.json', params).then (resp) ->
      rounds[resp.data.id] = null

RoundAPIService.$inject = [
  '$http'
  '$q'
  '$location'
]

module.exports = RoundAPIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/remote-api/round-api-service.coffee